/*
 * Forte Plus LT — localise the Releasit order-summary tax note (16-10-2026).
 * Releasit prints the amount with a dot and no currency ("Įskaičiuota 12.73 mokesčių",
 * or the English "Including 12.73 in taxes"); this rewrites it as "Įskaičiuotas PVM: 12,73 €".
 * Text only — the node is re-rendered by Releasit whenever the total changes, so it polls.
 */
setInterval(function () {
  document.querySelectorAll('.rsi-total-summary-taxes-note').forEach(function (el) {
    var text = (el.textContent || '').trim();
    if (text.indexOf('Įskaičiuotas PVM:') === 0) return;
    var m = text.match(/Įskaičiuota\s+(.+?)\s+mokesčių/i) || text.match(/Including\s+(.+?)\s+in\s+taxes/i);
    if (!m) return;
    var d = m[1].replace(/[^\d.,-]/g, '');
    if (/^\d{1,3}(\.\d{3})+$/.test(d)) d = d.replace(/\./g, '');
    d = /,\d{1,2}$/.test(d) ? d.replace(/\./g, '').replace(',', '.') : d.replace(/,/g, '');
    var n = parseFloat(d);
    el.textContent = isNaN(n) ? 'Įskaičiuotas PVM: ' + m[1] + ' €'
      : 'Įskaičiuotas PVM: ' + new Intl.NumberFormat('lt-LT', { style: 'currency', currency: 'EUR' }).format(n);
  });
}, 500);
